import { InfoCircleOutlined } from "@ant-design/icons";
import { Skeleton, Tooltip } from "antd";
import React from "react";

import { Col, DefaultBadge, DefaultInfo, SeriesHeaderRow } from "../styles";
import { DefaultSerie } from "../types";

const DEFAULT_TOOLTIP =
  "Valores padrão de série e numeração vindos da Focus (provedor de NFCe). " +
  "São usados quando o canal não tem uma série própria definida.";

const NEXT_NUMBER_TOOLTIP =
  "O próximo número é por série: canais com a mesma série compartilham o mesmo " +
  "número (o último valor digitado vale para todos). Sem série, ou série igual " +
  "à padrão, o próximo número não se aplica.";

interface SeriesHeaderProps {
  defaultSerie?: DefaultSerie;
  loading?: boolean;
}

const SeriesHeader: React.FC<SeriesHeaderProps> = ({
  defaultSerie,
  loading,
}) => (
  <>
    <DefaultInfo>
      <DefaultBadge>
        Padrão Focus{" "}
        <Tooltip title={DEFAULT_TOOLTIP}>
          <InfoCircleOutlined />
        </Tooltip>
      </DefaultBadge>
      <span>
        Série:{" "}
        {loading ? (
          <Skeleton.Input active size="small" />
        ) : (
          <strong>{defaultSerie?.serie ?? "—"}</strong>
        )}
      </span>
      <span>
        Próximo número:{" "}
        {loading ? (
          <Skeleton.Input active size="small" />
        ) : (
          <strong>{defaultSerie?.invoiceSequence ?? "—"}</strong>
        )}
      </span>
    </DefaultInfo>

    <SeriesHeaderRow gutter={16} align="middle">
      <Col span={4}>Canal</Col>
      <Col span={5}>
        Série atual{" "}
        <Tooltip title="Série atualmente em uso para este canal.">
          <InfoCircleOutlined />
        </Tooltip>
      </Col>
      <Col span={5}>
        Próximo número{" "}
        <Tooltip title="Próximo número de nota desta série.">
          <InfoCircleOutlined />
        </Tooltip>
      </Col>
      <Col span={5}>Nova série</Col>
      <Col span={5}>
        Próximo número{" "}
        <Tooltip title={NEXT_NUMBER_TOOLTIP}>
          <InfoCircleOutlined />
        </Tooltip>
      </Col>
    </SeriesHeaderRow>
  </>
);

export default SeriesHeader;
